export enum LookCellsGridScenario {
  ThreeLooks,
  FourLooks,
  SingleRow,
  SingleRowPlus,
  DivisibleByThree,
  DivisibleByTwo
}

const THREE = 3;
const FOUR = 4;
const NINE = 9;
const MAXIMUM_NUMBER_FOR_ONE_ROW = 18;
const MAXIMUM_NUMBER_FOR_TWO_ROWS = 26;

type HasGalleryViewLinkPlaceholder = boolean | undefined;

export const getLookCellsGridScenario = (
  numberOfLooks: number
): {
  scenario: LookCellsGridScenario;
  hasGalleryViewLinkPlaceholder: HasGalleryViewLinkPlaceholder;
} => {
  if (numberOfLooks <= THREE) {
    return { scenario: LookCellsGridScenario.ThreeLooks, hasGalleryViewLinkPlaceholder: false };
  }

  if (numberOfLooks <= FOUR) {
    return { scenario: LookCellsGridScenario.FourLooks, hasGalleryViewLinkPlaceholder: false };
  }

  if (numberOfLooks <= NINE) {
    return { scenario: LookCellsGridScenario.SingleRowPlus, hasGalleryViewLinkPlaceholder: false };
  }

  if (numberOfLooks <= MAXIMUM_NUMBER_FOR_ONE_ROW) {
    return { scenario: LookCellsGridScenario.SingleRow, hasGalleryViewLinkPlaceholder: false };
  }

  if (numberOfLooks <= MAXIMUM_NUMBER_FOR_TWO_ROWS) {
    if (numberOfLooks % 2 === 0) {
      return {
        scenario: LookCellsGridScenario.DivisibleByTwo,
        hasGalleryViewLinkPlaceholder: false
      };
    }
    return { scenario: LookCellsGridScenario.DivisibleByTwo, hasGalleryViewLinkPlaceholder: true };
  }

  if (numberOfLooks % THREE === 0) {
    return {
      scenario: LookCellsGridScenario.DivisibleByThree,
      hasGalleryViewLinkPlaceholder: false
    };
  }
  if (numberOfLooks % THREE === 2) {
    return {
      scenario: LookCellsGridScenario.DivisibleByThree,
      hasGalleryViewLinkPlaceholder: true
    };
  }

  if (numberOfLooks % 2 === 0) {
    return { scenario: LookCellsGridScenario.DivisibleByTwo, hasGalleryViewLinkPlaceholder: false };
  }
  return { scenario: LookCellsGridScenario.DivisibleByTwo, hasGalleryViewLinkPlaceholder: true };
};
